@let user = user$ | async;
<section
  [ngStyle]="{'--sidebar-width': sidebarOpen() ? '12.875rem' : '3.125rem'}"
  class="dashboard-container"
>
  <header
    class="dashboard-container__header z-10 pl-2 pr-4 flex items-center gap-2 sticky top-0 border-b border-stone-300 !bg-stone-200">
    <button (click)="toggleSideBar()" [matTooltip]="sidebarOpen() ? 'Close Sidebar' : 'Open Sidebar'"
            class="!flex items-center"
            mat-icon-button>
      @if (sidebarOpen()) {
        <mat-icon>left_panel_close</mat-icon>
      } @else {
        <mat-icon>left_panel_open</mat-icon>
      }
    </button>
    <div class="font-medium text-sm">
      <!-- Breadcrumbs -->
      <p-breadcrumb [model]="breadcrumbs()">
        <ng-template #separator> /</ng-template>
      </p-breadcrumb>
      <h1 class="text-base">{{ pageTitle() }}</h1>
    </div>
    <div class="grow"></div>
  </header>
  <aside class="h-screen bg-stone-200 dashboard-container__navbar">
    <p-menu
      [model]="items"
      styleClass="min-w-0 flex flex-col px-1.5 bg-stone-200 border-y-0 border-l-0 border-r border-stone-300 w-full h-full"
    >
      <ng-template #submenuheader let-item></ng-template>
      <ng-template #item let-item>
        <a
          [routerLinkActiveOptions]="{exact: item.label === 'Home'}"
          [routerLink]="item.path"
          class="mb-1 px-1.5 py-1 rounded-md border border-transparent flex items-center gap-3 text-sm text-stone-800"
          matTooltip="{{ item.label }}"
          matTooltipPosition="right"
          pRipple
          routerLinkActive="!border-stone-400 bg-white"
        >
          <div class="flex text-stone-600">
            <mat-icon>{{ item.icon }}</mat-icon>
          </div>
          @if (sidebarOpen()) {
            <span class="text-sm font-semibold text-nowrap overflow-hidden text-ellipsis">{{ item.label }}</span>
          }
        </a>
      </ng-template>
      <ng-template #end>
        <button (click)="userPopover.toggle($event)"
                class="p-menu-item-content w-full border-t border-stone-300 px-1.5 py-3 flex gap-3 items-center"
                pRipple>
          <span class="flex text-stone-600">
            <mat-icon>person</mat-icon>
          </span>
          @if (sidebarOpen()) {
            <span class="grow flex flex-col justify-start items-start">
            <span
              class="text-sm text-left block text-nowrap font-semibold text-stone-800 overflow-hidden text-ellipsis">{{ user?.firstName ? (user?.firstName | titlecase) : (user?.username | titlecase) }}</span>
            </span>
            <span class="flex text-stone-600">
              <mat-icon>chevron_right</mat-icon>
            </span>
          }
        </button>
        <p-popover #userPopover>
          <div class="w-72 pt-3 text-stone-600">
            <p class="mx-3 mb-2 uppercase font-semibold text-xs ">Signed in as</p>
            <div class="mb-2 px-1">
              <button [routerLink]="['/settings/profile']"
                      class="p-2 w-full flex items-center gap-2 rounded hover:bg-stone-200">
                               <span
                                 class="flex items-center justify-center border border-stone-300 w-10 h-10 rounded-full">
                                   <mat-icon>person</mat-icon>
                               </span>
                <span class="grow flex flex-col items-start text-sm text-stone-800">
                                    <span
                                      class="font-semibold leading-tight">{{ user?.firstName ? (user?.firstName | titlecase) : (user?.username | titlecase) }}</span>
                                    <span class="leading-tight">{{ user?.email }}</span>
                                </span>
                <span class="flex text-stone-500">
                                    <mat-icon>settings</mat-icon>
                                </span>
              </button>
            </div>
            <hr/>
            <p class="mx-3 mt-3 mb-2 uppercase font-semibold text-xs">Current Role</p>
            <div class="mb-2 px-1 text-stone-800">
              <p class="font-semibold text-sm px-2">{{ user?.role?.name }}</p>
            </div>
            <hr/>
            <div class="py-2 px-1">
              <button class="p-2 w-full flex items-center gap-2 rounded hover:bg-stone-200">
                               <span class="flex">
                                   <mat-icon>logout</mat-icon>
                               </span>
                <button (click)="signOut()" aria-label="Sign Out of the application"
                        class="grow flex flex-col items-start font-semibold text-sm text-stone-800">
                  Sign Out
                </button>
              </button>
            </div>
          </div>
        </p-popover>
      </ng-template>
    </p-menu>
  </aside>
  <section
    [ngStyle]="{'--mat-sidenav-container-width': sidebarOpen() ? '12.875rem' : '3.125rem'}"
    class="bg-stone-100 dashboard-container__content grid gap-2 items-stretch"
  >
    <section class="overflow-auto">
      <router-outlet></router-outlet>
    </section>
  </section>
  <section class="dashboard-container__sidebar"></section>
</section>
